import { IncomeStatementId, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { incomeStatementsQueryKey } from "../../financials";

export function useAdminDeleteIncomeStatement(accountId: SuretyAccountId) {
	const { _delete } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (incomeStatementId: IncomeStatementId) =>
			_delete(
				`/v2/admin/surety/accounts/${accountId}/income-statements/${incomeStatementId}`,
				undefined,
				"none",
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: incomeStatementsQueryKey(accountId) });
		},
	});

	return {
		deleteIncomeStatement: mutation.mutate,
		deleteISLoading: mutation.isPending,
		deleteISError: mutation.error,
		resetDeleteISError: mutation.reset,
	};
}
